// Product gallery thumb switching
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-thumb]');
  if (!t) return;
  const url = t.dataset.thumb;
  const main = document.querySelector('[data-main-image]');
  if (main) main.src = url;
  document.querySelectorAll('[data-thumb]').forEach(b => b.classList.remove('active'));
  t.classList.add('active');
});

function strictlyToddlersCartConfetti() {
  const cartLink =
    document.querySelector('a[href="/cart"]') ||
    document.querySelector('a[href*="cart"]');

  if (!cartLink) return;

  const rect = cartLink.getBoundingClientRect();
  const x = rect.left + rect.width / 2;
  const y = rect.top + rect.height / 2;

  const colors = ["#3B2114", "#FFF7E8", "#E8C27A", "#F6D9E7"];

  for (let i = 0; i < 14; i++) {
    const piece = document.createElement("span");
    piece.className = "cart-confetti";
    piece.style.background = colors[Math.floor(Math.random() * colors.length)];
    piece.style.left = x + "px";
    piece.style.top = y + "px";
    piece.style.setProperty("--x", Math.random() * 120 - 60 + "px");
    piece.style.setProperty("--y", -Math.random() * 100 - 35 + "px");

    document.body.appendChild(piece);

    piece.addEventListener("animationend", function () {
      piece.remove();
    });
  }
}

document.addEventListener("click", function (e) {
  const addButton = e.target.closest(
    'button[name="add"], button[type="submit"], .product-form__submit'
  );

  if (!addButton) return;

  setTimeout(strictlyToddlersCartConfetti, 500);
});